module.exports = __webpack_public_path__ + "img/menu-logout.ee0ab2ff.svg";